import { ClientEvent } from '@udemy/event-tracking';

/**
 * This event is fired when the "Manage" button in the UB header (available to admins
 * and group admins) is selected.
 */
export class ManageOrganizationSelected extends ClientEvent {
  constructor() {
    super('ManageOrganizationSelected');
  }
}
//# sourceMappingURL=events.js.map